import { render, staticRenderFns } from "./genre.vue?vue&type=template&id=d4ca42a4&scoped=true"
import script from "./genre.vue?vue&type=script&lang=js"
export * from "./genre.vue?vue&type=script&lang=js"
import style0 from "./genre.vue?vue&type=style&index=0&id=d4ca42a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ca42a4",
  null
  
)

export default component.exports